import { BaseUrl } from './ApiUrl'
import AXIOS_SERVICE from '../utils/AxiosUtil'

const HealthService = () => {}
HealthService.Check = async()=> {  
 return await AXIOS_SERVICE('get', `${BaseUrl}/health`, {})
}

export default HealthService